// extracted by mini-css-extract-plugin
export default {"container":"form-tree_container__ssQwI","container-collapsed":"form-tree_container-collapsed__aIRG5","option":"form-tree_option__-ceYn","skeleton":"form-tree_skeleton__p37O3"};